import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import {useTheme} from '@mui/material/styles';

import JdNoticeBanner from '@components/JdNoticeBanner';
import {deferTask, openUrl} from '@jobseeker/common-core/utils/common';

type AtsApplyBannerProps = {
  applyUrl: string;
};
// Shown after applying to a job that redirects the jobseeker to the
// recruiter's own ATS/portal (IIMHIRJS-3874) — lets them resume the
// application here if they didn't finish it on that redirect.
const AtsApplyBanner = ({applyUrl}: AtsApplyBannerProps) => {
  const theme = useTheme();
  const accentColor = theme.palette.primary.main;

  return (
    <JdNoticeBanner>
      <Box component="span" fontWeight={700}>
        Note:
      </Box>{' '}
      For your candidature to be considered, you must apply on the
      company&apos;s redirected page for this job. If you missed it,{' '}
      <Link
        href={applyUrl}
        onClick={e => {
          e.preventDefault();
          deferTask(() => openUrl(applyUrl, '_blank'));
        }}
        sx={{
          fontWeight: 600,
          cursor: 'pointer',
          color: accentColor,
          whiteSpace: {xxs: 'nowrap', md: 'normal'},
        }}
      >
        complete your application here →
      </Link>
    </JdNoticeBanner>
  );
};

export default AtsApplyBanner;
